import { render, staticRenderFns } from "./phrase.vue?vue&type=template&id=a0330156&scoped=true"
import script from "./phrase.vue?vue&type=script&lang=js"
export * from "./phrase.vue?vue&type=script&lang=js"
import style0 from "./phrase.vue?vue&type=style&index=0&id=a0330156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0330156",
  null
  
)

export default component.exports